import React from "react";
import { TextLg, TextMd, TextSm } from "../../../components/text";
import urlIcon from '../../../assets/icons/url.svg';

const history = [
  {
    years: "2025 - Present",
    title: "Full Stack Developer",
    company: "Iron Shield Roofing",
    href: "https://ironshieldroofingtx.com",
    description: "Developing and maintaining custom web applications and internal tooling to streamline operations, and support company growth.",
    highlights: [
      "Built and deployed modern React applications and internal business tools",
      "Implemented cloud-based infrastructure and deployment processes using Firebase",
      "Improved user experience and site performance through responsive design and optimization"
    ],
  },
  {
    years: "2022 - 2025",
    title: "Senior Data Analyst",
    company: "Presto",
    href: "https://presto.com",
    description: "Leading analytics initiatives, reporting and process automation, and dashboard development to improve operational efficiency.",
    highlights: [
      "Built automated reporting workflows and process workflows, reducing manual effort",
      "Completed site integrations, tying together our customer support, business management, and CRM systems",
      "Developed interactive business intelligence dashboards",
    ],
  },
  {
    years: "2020 - 2022",
    title: "Data Analyst",
    company: "Presto",
    href: "https://presto.com",
    description: "Delivered actionable insights through data visualization, reporting, and process automation.",
    highlights: [
      "Developed interactive business intelligence dashboards",
      "Created data pipelines and analytics tooling",
      "Performed ad-hoc business analysis",
    ],
  },
];

export const WorkHistory = ({ className = "", style = {} }) => {
  return (
    <section className={`relative ${className}`} style={style}>
      <TextMd className="font-bold text-gray-600 mb-10">Work History</TextMd>

      {/* Timeline */}
      <div className="relative">
        {/* Main timeline */}
        <div className="absolute left-[7px] top-0 bottom-0 w-1 rounded-full bg-gray-500/15" />

        {/* Active section */}
        <div
          className={`
            absolute left-[7px] top-0
            w-1 h-24 rounded-full
            bg-gradient-to-b
            from-blue-500
            to-gray-200
          `}
        />

        {history.map((job, index) => (
          <div
            key={index}
            className="relative grid grid-cols-[40px_1fr] gap-6"
          >
            {/* Timeline Node */}
            <div className="relative">
              <div
                className={`
                  absolute top-0 left-0
                  w-4 h-4 rounded-full z-10
                  transition-colors
                  ${
                    index === 0
                      ? "bg-blue-500 shadow-[0_0_12px_rgba(59,130,246,.4)] pulse-ring"
                      : "bg-gray-300"
                  }
                `}
              />
            </div>

            {/* Content */}
            <div className="flex flex-col gap-3 py-3">
              <div className="flex flex-col">
                <div
                  className={`
                    text-sm font-medium
                    ${index === 0 ? "text-blue-500" : "text-gray-400"}
                  `}
                >
                  {job.years}
                </div>

                <div className="text-xl font-semibold text-gray-800">
                  {job.title}
                </div>

                <a 
                  className="text-gray-500 flex items-center gap-2 w-fit px-3 py-1 relative right-3"
                  target="_blank"
                  href={job.href}
                >
                  <TextSm>{ job.company }</TextSm>
                  <img className="h-3" src={urlIcon} />
                </a>
              </div>

              <TextMd className="text-gray-700 mb-3">{job.description}</TextMd>

              <ul className="space-y-2 text-gray-500 relative right-4">
                {job.highlights.map((item, i) => (
                  <li key={i} className="flex gap-3 items-center">
                    <span
                      className={`
                        w-2 h-2 min-w-2 min-h-2 rounded-full
                        ${ index === 0 ? "bg-blue-500" : "bg-gray-400" }
                      `}
                    />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>

              {
                index !== (history.length - 1) && (
                  <div className="mx-6 h-px bg-neutral-500/15 mt-3" />
                )
              }
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
